import dayjs from 'dayjs';

const isAfterNow = (val) => dayjs(val).isAfter(dayjs());

export default isAfterNow;
